import resume from '../assets/pdf/rohit_resume.pdf'
import masaipic from './rohit.png'
export const headerData = {
    name: 'Rohit Kumar',
    title: "Full-stack Web Developer",
    desciption:"My passion for software lies with dreaming up ideas and making them come true with elegant interfaces. I take great care in the experience, architecture, and code quality of the things I build. ",
    image: masaipic,
    resumePdf: resume
}
